<template>
  <div class="index-view">
    <div class="index-view_left">
      <div class="ddiv">
        <div class="styleNo">Design No. {{desNo}}</div>
        <div class="styleNo">PO No. {{poNo}}</div>
        <div class="init3d" :style="mypagestyle">
          <!--
          <div class="ctrlBtnBar">
            <div class="ctrlBtn">
              <el-button style="width: 42px;height: 42px; margin: 5px;" color="#909399" size="large" @click="ResetPos" circle>
                <el-icon :size="25" color="#ffffff">
                  <refresh-left />
                </el-icon>
              </el-button>
              <div class="ctrlBtnDesc">Start Over</div>
            </div>
            <div class="ctrlBtn" v-if="!isAutoRotate">
              <el-button style="width: 42px;height: 42px; margin: 5px;" color="#909399" size="large" @click="StarRotate" circle>
                <el-icon :size="25" color="#ffffff">
                  <video-play />
                </el-icon>
              </el-button>
              <div class="ctrlBtnDesc">Rotate</div>
            </div>
            <div class="ctrlBtn" v-if="isAutoRotate">
              <el-button style="width: 42px;height: 42px; margin: 5px;" color="#909399" size="large" @click="StopRotate" circle>
                <el-icon :size="25" color="#ffffff">
                  <video-pause />
                </el-icon>
              </el-button>
              <div class="ctrlBtnDesc">Pause</div>
            </div>

            <div class="sizeSlider">
              <el-slider v-model="sizeValue" vertical height="200px" @input="zoomCamera"/>
            </div>

          </div>
          -->
          <div class="web3ddiv">
            <div id="web3d" />
          </div>
        </div>

        <el-row style="justify-content: center; margin-top: 20px;">
          <el-button color="#909399" size="large" @click="StarRotate" style="width:50px;height:50px;" circle>
            <el-icon :size="25" color="#ffffff">
              <video-play />
            </el-icon>
          </el-button>
          <el-button color="#909399" size="large" @click="StopRotate" style="width:50px;height:50px;" circle>
            <el-icon :size="25" color="#ffffff">
              <video-pause />
            </el-icon>
          </el-button>
          <el-button color="#909399" size="large" @click="ResetPos" style="width:50px;height:50px;" circle>
            <el-icon :size="25" color="#ffffff">
              <refresh-left />
            </el-icon>
          </el-button>
          <el-button color="#909399" size="large" style="width:50px;height:50px;" v-if="haveAnnotation" @click="AnnotationSwitch()" circle>
            <el-icon :size="25" color="#ffffff">
              <chat-line-square />
            </el-icon>
          </el-button>
          <el-button color="#909399" size="large" style="width:50px;height:50px;" v-if="annotationIsOn" @click="AnnotationSelect(-1)" circle>
            <el-icon :size="25" color="#ffffff">
              <caret-left />
            </el-icon>
          </el-button>
          <el-button color="#909399" size="large" style="width:50px;height:50px;" v-if="annotationIsOn" @click="AnnotationSelect(1)" circle>
            <el-icon :size="25" color="#ffffff">
              <caret-right />
            </el-icon>
          </el-button>
        </el-row>

      </div>
    </div>
    <div class="content">
      <div class="metalPreviewTitle">Addtional Metal Color Options:</div>
      <div class="metalPreviewDesc">*For reference only. The final metal color of your custom item is subject to directions supplied to us through your order.
      </div>
      <el-collapse v-model="activeNames" @change="handleChange">
        <el-collapse-item v-for="(value,key) in layersInfo.value" :key="key" :title=" `PART ${key+1} : Metal Color`" name="1" v-show="value.type == 0">
          <div class="content-metal_selector" v-if="value.type == 0">
            <div class="metal_selector_div">
              <el-image src="./static/images/Metal_WhiteGold_icon.png" :fit="fit" />
              <el-radio size="large" v-model="radioBtnMetal[key]" :label="value.name + 2" @change="((val) => {ChangeMetal(val, value, 2)})">
                White
              </el-radio>
            </div>
            <div class="metal_selector_div">
              <el-image src="./static/images/Metal_YellowGold_icon.png" :fit="fit" />
              <el-radio v-model="radioBtnMetal[key]" :label="value.name + 3" @change="((val) => {ChangeMetal(val, value, 1)})">
                Yellow
              </el-radio>
            </div>
            <div class="metal_selector_div">
              <el-image src="./static/images/Metal_RoseGold_icon.png" :fit="fit" />
              <el-radio v-model="radioBtnMetal[key]" :label="value.name + 4" @change="((val) => {ChangeMetal(val, value, 3)})">
                Rose
              </el-radio>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<script>
  import
  {
    common
  }
  from '@/api/index.js'
  import
  {
    onMounted,
    ref,
    reactive
  }
  from "vue";
  import
  {
    useRoute
  }
  from 'vue-router'

  let baseUrl = "./static";
  let resourceDomainName = 'https://design.bavlo.com/';
  let metals, gems, metalWebDefault, metalWebUser, gemWebDefault, gemWebUser;
  let webModelPics;
  let imageEngraves;
  let my3d;
  let designInfo;
  let userNo = 20241;
  let userInfo;
  let urlQuery;
  let designNo;
  let sodNo;
  let desAnnotationList;
  let sizeValue;
  const height = document.documentElement.clientWidth;

  export default (
  {
    setup()
    {
      let styleNo = ref('0/0');
      let desNo = ref('none');
      let poNo = ref('none');
      let drawer = ref(false);
      let route = useRoute();
      let designTypeId = ref('');
      let designTypeName = ref('');
      let activeName = ref(0);
      let checkedTryOn = ref(false);
      let radioBtnEngrave = ref(0);
      let radioBtnStone = reactive(new Array(10).fill([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]));
      let radioBtnMetal = reactive(new Array(10).fill([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]));
      let radioBtnOther = reactive(new Array(10).fill([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]));
      let customizeEngraveText = ref('');
      let drawerVisiable = ref(false);
      let oriPrice = ref('700');
      let confPrice = ref('700');
      const mypagestyle = reactive(
      {
        height: ''
      });
      const confData = reactive(
      {
        param1: '',
        param2: '',
        param3: '',
      });
      const layersInfo = reactive(
      {});
      const otherGems = reactive([]);
      let activeNames = ref(['1']);
      const
      {
        LoadDesignInfo,
        LoadMetalWeb,
        LoadAllMetals,
        LoadGemWeb,
        LoadAllGems,
        LoadModelPicList,
        GetImageEngraveList,
        LoadUserInfo,
        LoadDesAnnotationList
      } = common();

      // onMounted
      onMounted(() =>
      {
        init();

        if (height < 415)
        {
          mypagestyle.height = height + 'px';
        }

        window.onresize = () =>
        {
          my3d.onWindowResize(2);
        }
      })

      // 初始化
      const init = async () =>
      {
        //接收query
        urlQuery = route.query;
        // console.log(JSON.stringify(urlQuery));
        //提取参数, 转int形式
        designNo = parseInt(urlQuery.vdesid);
        sodNo = parseInt(urlQuery.sodno)
        //获取数据
        await LoadMetalWeb(0).then(res =>
        {
          metalWebDefault = res.list;
        });
        await LoadMetalWeb(userNo).then(res =>
        {
          metalWebUser = res.list;
        });
        await LoadAllMetals().then(res =>
        {
          metals = res.list;
        });
        await LoadGemWeb(0).then(res =>
        {
          gemWebDefault = res.list;
        });
        await LoadGemWeb(userNo).then(res =>
        {
          gemWebUser = res.list;
        });
        await LoadAllGems().then(res =>
        {
          gems = res.list;
        });
        await LoadDesignInfo(designNo).then(res =>
        {

          designInfo = res.designInfo;
          styleNo.value = res.designInfo.styleNo;
          var tempNo = styleNo.value.split('/');
          desNo.value = tempNo[0];
          poNo.value = tempNo[1];
          // console.log(designInfo)
          designTypeId.value = designInfo.type.id;
          designTypeName.value = designInfo.type.nameEn;
          // console.log(designTypeId.value + ", " + designTypeName.value);
        });
        await LoadUserInfo(userNo).then(res =>
        {
          userInfo = res.user;
        });
        await LoadDesAnnotationList(designNo).then(res =>
        {
          desAnnotationList = res.list;
          if (desAnnotationList.length > 0)
          {
            haveAnnotation.value = true;
          }
          else
          {
            haveAnnotation.value = false;
          }
        })

        //初始化3D场景
        const initParameter = {
          baseUrl: baseUrl,
          controlElementId: 'web3d',
          isEdit: false,
          resourceDomainName: resourceDomainName,
          isDesign: true,
          isRhino5: true,
        }
        my3d = Bavlo.initWeb3dScene(initParameter);
        //设定3D场景尺寸
        my3d.onWindowResize(2);
        //初始化材质
        my3d.initUserMatInfo(metalWebDefault, metalWebUser, gemWebDefault, gemWebUser);
        //加载固定款
        my3d.loadDesign(designInfo);
        // console.log("Load model Done!!!")

        //提取图层信息，用于后续处理
        layersInfo.value = designInfo.layers;
        console.log(layersInfo)
        //提取其他类型宝石的材质信息（非钻石）
        if (designInfo.otherGems)
        {
          designInfo.otherGems.filter(function(item1)
          {
            otherGems.push(item1);
          });
        }
      }

      //////////////////////
      // 以下是3D控件的方法
      //////////////////////
      // 停止模型自旋转
      let isAutoRotate = ref(true);
      const StopRotate = () =>
      {
        isAutoRotate.value = false;
        my3d.setRotationState(isAutoRotate.value);
      }

      // 开启模型自旋转
      const StarRotate = () =>
      {
        isAutoRotate.value = true;
        my3d.setRotationState(isAutoRotate.value);
      }

      // 重置姿态
      const ResetPos = () =>
      {
        my3d.postureReset();
      }

      // 摄像头距离
      const ZoomCamera = () =>
      {
        my3d.zoomCamera(this.sizeValue);
      }

      // 标注开关
      let haveAnnotation = ref(false);
      let annotationIsOn = ref(false);
      let annotationIndex = ref(-1);
      const AnnotationSwitch = () =>
      {
        annotationIsOn.value = !annotationIsOn.value;
        if (annotationIsOn.value === true)
        {
          // console.log("Annotation Is On !!!");
          my3d.setAnnotationList(desAnnotationList);
          my3d.setAnnotationState(true);
        }
        else
        {
          // console.log("Annotation Is Closes !!!");
          my3d.setAnnotationState(false);
        }

        my3d.setRotationState(true);
      }

      // 标注选择
      const AnnotationSelect = (step) =>
      {
        //先停止自转
        my3d.setRotationState(false);

        annotationIndex.value = annotationIndex.value + step;
        if (annotationIndex.value < 0)
        {
          annotationIndex.value = desAnnotationList.length - 1;
        }
        if (annotationIndex.value > desAnnotationList - 1)
        {
          annotationIndex.value = 0;
        }

        let desAnnotation = desAnnotationList[annotationIndex.value];
        my3d.switchAnnotation(desAnnotation.id);
      }

      // 重置搭配
      const ResetAllConfig = () =>
      {
        my3d.removeCustomization();
        for (let i = 0; i < 10; i++)
        {
          this.radioBtnMetal[i] = -1;
          this.radioBtnStone[i] = -1;
          this.radioBtnOther[i] = -1;
        }
        this.$forceUpdate();
      }

      // 改变宝石
      const ChangeStone = (val, layer, matID) =>
      {
        let layerName = layer.name;
        let ogType = layer.ogType;
        let faceType = layer.gem.faceType;
        // console.log(layerName);
        // console.log(ogType);
        // console.log(faceType);

        if (ogType == 0)
        {
          let matClass = gems.filter(function(item)
          {
            return item.id == matID;
          })[0];
          // console.log(matClass);
          if (faceType == 'faceted')
          {
            my3d.customizeGemClass(ogType, layerName, matClass);
          }
          else
          {
            my3d.changeLayerMaterial(layerName, matClass);
          }
        }

        if (ogType == 1)
        {
          let matClass
          if (otherGems[0].gemDetals)
          {
            let materials = otherGems.filter(function(item)
            {
              return item.id == layer.otherGem.gemType.id;
            })[0];
            matClass = materials.gemDetals.filter(function(item)
            {
              return item.id == matID;
            })[0];
          }
          else
          {
            matClass = otherGems.filter(function(item)
            {
              return item.id == matID;
            })[0];
          }
          material.refraction = layer.otherGem.gemType.refraction;
          my3d.customizeGemClass(ogType, layerName, matClass);
        }
      }

      // 改变金属
      const ChangeMetal = (val, layer, matID) =>
      {
        let layerName = layer.name;
        //console.log("layerName: " + layerName);
        //console.log("targetMat: " + matID);
        let matClass = metals.filter(function(item)
        {
          return item.id == matID;
        })[0];
        //console.log("matData: ↓");
        //console.log(matClass);
        my3d.customizeMetalClass(layerName, matClass);
      }

      // 模特试戴
      const TryOnCheckBoxChange = async (val) =>
      {
        await this.loadModelPicList(0, this.designTypeId).then(res =>
        {
          webModelPics = res.list;
          // console.log(webModelPics);
        });

        if (val == true)
        {
          let dheight = this.$refs.div3dview.style.height;
          console.log(dheight)
          return false
          let dwidth = 660 / 4 * 3 + 'px';
          this.$refs.div3dview.style.width = dwidth;
          //比例类型 0为3:4 1为4:3 2为当前div大小
          my3d.onWindowResize(2);
          let nowModelPic = webModelPics[0];
          nowModelPic.imgUrl = 'https://design.bavlo.com/WebModelPics/' + nowModelPic.userId + '/' + nowModelPic.name;
          my3d.setModelTryonMode(true, nowModelPic);
        }
        else
        {
          my3d.setModelTryonMode(false, null);
          this.$refs.div3dview.style.height = "660px";
          this.$refs.div3dview.style.width = "660px";
          //比例类型 0为3:4 1为4:3 2为当前div大小
          my3d.onWindowResize(2);
        }
      }

      // 图片刻印与刻印类型选择
      const SetImageEngrave = async (val, layerId) =>
      {
        if (this.radioBtnEngrave == 0)
        {
          // console.log("Is setting no engrave");
          my3d.printUserTextOfLayer(layerId, " ");
        }
        if (this.radioBtnEngrave == 1)
        {
          // console.log("Is setting image engrave");
          await getImageEngraveList(layerId, 0).then(res =>
          {
            imageEngraves = res.list;
            // console.log(imageEngraves);
          });
          let imageEngrave = imageEngraves.filter(function(item)
          {
            return item.layerId == layerId;
          })[0];
          // console.log(imageEngrave);
          let imageFileName = imageEngrave.imgUrl;
          let imageFullUrl = 'https://design.bavlo.com/ImageEngrave/design/' + layerId + '/' + imageFileName;
          my3d.setImageOfLayer(layerId, imageFullUrl);
          let scale = JSON.parse(imageEngrave.scale);
          let rot = JSON.parse(imageEngrave.rot);
          let offset = JSON.parse(imageEngrave.offset);
          my3d.editImageOfLayer(layerId,
          {
            x: scale.x,
            y: scale.y
          },
          {
            x: rot.x
          },
          {
            x: offset.x,
            y: offset.y
          });
          // console.log("Image engrave setting done!!!");
        }
        if (this.radioBtnEngrave == 2)
        {
          this.setTextEngrave(layerId);
        }
      }

      // 文字刻印
      const SetTextEngrave = (layerId) =>
      {
        if (this.radioBtnEngrave == 2)
        {
          // console.log("Is setting text engrave");
          // console.log("layerID: " + layerId);
          // console.log("Input text is: " + this.customizeEngraveText);
          my3d.printUserTextOfLayer(layerId, this.customizeEngraveText);
        }
      }
      // 3D控件的方法结尾//////////////////

      // return
      return {
        mypagestyle,
        otherGems,
        haveAnnotation,
        annotationIsOn,
        annotationIndex,
        activeNames,
        layersInfo,
        styleNo,
        poNo,
        desNo,
        radioBtnEngrave,
        radioBtnStone,
        radioBtnMetal,
        radioBtnOther,
        customizeEngraveText,
        drawerVisiable,
        oriPrice,
        confPrice,
        confData,
        designTypeId,
        designTypeName,
        route,
        activeName,
        checkedTryOn,
        init,
        drawer,
        LoadDesignInfo,
        LoadMetalWeb,
        LoadAllMetals,
        LoadGemWeb,
        LoadAllGems,
        LoadModelPicList,
        GetImageEngraveList,
        LoadUserInfo,
        LoadDesAnnotationList,
        isAutoRotate,
        StopRotate,
        StarRotate,
        ResetPos,
        ZoomCamera,
        AnnotationSwitch,
        AnnotationSelect,
        ResetAllConfig,
        ChangeStone,
        ChangeMetal,
        TryOnCheckBoxChange,
        SetImageEngrave,
        SetTextEngrave
      }
    }
  })
</script>

<style lang="scss">
</style>
